import React from "react";
import { DialogPanel, DialogTitle, TransitionChild } from "@headlessui/react";
import { X } from "lucide-react";
import { useIntl } from "react-intl";
import { IconButton } from "../../iconButton/iconButton";
// Centered on desktop, bottom sheet on mobile, so forms stay reachable above the keyboard (DESIGN.md §3/§13).
export default function ModalCore({ setOpen, title, children, widthClass = "w-full max-w-md" }) {
    const { formatMessage } = useIntl();
    return (<>
            {/* transition-opacity, not "all" — the default property would also animate the backdrop blur. */}
            <TransitionChild enter="transition-opacity ease-out-soft duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-out-soft duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                <div className="fixed inset-0 bg-gray-900/35 backdrop-blur-[2px]"/>
            </TransitionChild>

            <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-0 text-center sm:items-center sm:p-4">
                    <TransitionChild enter="transition-[opacity,translate,scale] ease-out-soft duration-200" enterFrom="opacity-0 translate-y-6 sm:translate-y-0 sm:scale-[0.97]" enterTo="opacity-100 translate-y-0 sm:scale-100" leave="transition-[opacity,translate,scale] ease-out-soft duration-150" leaveFrom="opacity-100 translate-y-0 sm:scale-100" leaveTo="opacity-0 translate-y-6 sm:translate-y-0 sm:scale-[0.97]">
                        <DialogPanel className={`
                                ${widthClass} flex max-h-[92dvh] transform flex-col rounded-t-2xl bg-white text-left
                                align-middle shadow-overlay sm:max-h-[88dvh] sm:rounded-2xl
                            `}>
                            <div aria-hidden={"true"} className={"mx-auto mt-2 h-1 w-9 shrink-0 rounded-full bg-line-strong sm:hidden"}/>

                            {/* DialogTitle holds only the text — including the close button made it announce "Title Close" on open. */}
                            <div className={"flex shrink-0 items-start gap-3 border-b border-line px-5 pb-3 pt-4 sm:px-6 sm:pt-5"}>
                                <DialogTitle className={"grow shrink text-lg font-semibold tracking-title text-gray-900 sm:text-xl"}>
                                    {title}
                                </DialogTitle>
                                <IconButton label={formatMessage({ id: "close", defaultMessage: "Close" })} onClick={() => setOpen(false)} className={"shrink-0 text-gray-500 hover:bg-sunken hover:text-gray-900"}>
                                    <X className={"h-5 w-5"}/>
                                </IconButton>
                            </div>

                            <div className={"grow overflow-y-auto overscroll-contain px-5 pt-4 pb-safe sm:px-6"}>{children}</div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </>);
}
//# sourceMappingURL=modalCore.jsx.map